import { Button } from "../../../components/Button";
import { FormGroup } from "../../../components/FormGroup";
import { FormLabel } from "../../../components/FormLabel";
import { FormActions } from "../../../components/FormActions";
import { InfoBox } from "../../../components/InfoBox";
import { API_BASE_URL } from "../../../constants/api";
import { IntegrationType } from "@KassaroAB/shared/types/enums/IntegrationType";
import { useTranslation } from "react-i18next";
import type { RestIntegration } from "@KassaroAB/shared/types/integrations/integration";

type RestIntegrationFortnox = Extract<
  RestIntegration,
  { type: IntegrationType.FORTNOX }
>;

interface FortnoxFormProps {
  storeId: string;
  integration?: RestIntegrationFortnox;
  onCancel: () => void;
}

export const FortnoxForm = ({
  storeId,
  integration,
  onCancel,
}: FortnoxFormProps) => {
  const { t } = useTranslation();
  const oauthUrl = `${API_BASE_URL}/stores/${storeId}/bookkeeping/integration/${IntegrationType.FORTNOX}/oauth2`;

  const handleOAuthClick = () => {
    window.location.href = oauthUrl;
  };

  if (integration) {
    return (
      <>
        <FormGroup>
          <FormLabel>{t("fortnoxIntegration.type")}</FormLabel>
          <div style={{ padding: "8px 0" }}>
            {t("fortnoxIntegration.name")}
          </div>
        </FormGroup>
        <InfoBox variant="info">{t("fortnoxIntegration.managedOAuth")}</InfoBox>
        <FormActions>
          <Button type="button" $color="secondary" onClick={onCancel}>
            {t("common.close")}
          </Button>
        </FormActions>
      </>
    );
  }

  return (
    <>
      <FormGroup>
        <FormLabel>{t("fortnoxIntegration.oauthSetup")}</FormLabel>
        <InfoBox variant="info">{t("fortnoxIntegration.connectInfo")}</InfoBox>
      </FormGroup>
      <FormActions>
        <Button type="button" $color="secondary" onClick={onCancel}>
          {t("common.cancel")}
        </Button>
        <Button type="button" onClick={handleOAuthClick}>
          {t("fortnoxIntegration.connectButton")}
        </Button>
      </FormActions>
    </>
  );
};
